import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/layout/Layout.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

export const constantRoutes = [
  { path: '/login', name: 'Login', component: () => import('../views/login/Index.vue') },
  { path: '/404', name: 'Page404', component: () => import('../views/error/404.vue') },
  {
    path: '/sso/fastadmin',
    name: 'FastAdminSso',
    component: () => import('../views/sso/FastAdmin.vue'),
    meta: { title: 'FastAdmin SSO' },
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard/index',
    children: [
      {
        path: "/dashboard/index",
        name: "DashboardIndex",
        component: () => import("../views/dashboard/Index.vue"),
        meta: { title: "控制台首页" }
      },
      {
        path: '/exam/paper/edit',
        name: 'ExamPaperEdit',
        component: () => import('../views/exam/PaperEdit.vue'),
        meta: { title: '鍒涘缓璇曞嵎', activeMenu: '/exam/paper' },
        hidden: true
      },
      {
        path: '/exam/independent/edit',
        name: 'IndependentExamEdit',
        component: () => import('../views/exam/IndependentExamEdit.vue'),
        meta: { title: '鍒涘缓鑰冭瘯', activeMenu: '/exam/independent' },
        hidden: true
      },
      {
        path: '/operations/surveys/edit',
        name: 'SurveyEdit',
        component: () => import('../views/operation/SurveyEdit.vue'),
        meta: { title: '鍒涘缓闂嵎', activeMenu: '/operations/surveys' },
        hidden: true
      },
      {
        path: '/operations/surveys/statistics',
        name: 'SurveyStatistics',
        component: () => import('../views/operation/SurveyStatistics.vue'),
        meta: { title: '闂嵎缁熻', activeMenu: '/operations/surveys' },
        hidden: true
      },
      {
        path: '/operations/survey-tasks/edit',
        name: 'SurveyTaskEdit',
        component: () => import('../views/operation/SurveyTaskEdit.vue'),
        meta: { title: '创建调研任务', activeMenu: '/operations/survey-tasks' },
        hidden: true
      },
      {
        path: '/operations/survey-tasks/statistics',
        name: 'SurveyTaskStatistics',
        component: () => import('../views/operation/SurveyTaskStatistics.vue'),
        meta: { title: '调研数据分析', activeMenu: '/operations/survey-tasks' },
        hidden: true
      },
      {
        path: '/learning/courses',
        name: 'CourseList',
        component: () => import('../views/learning/CourseList.vue'),
        meta: { title: '课程管理' }
      },
      {
        path: '/learning/courses/edit',
        name: 'CourseEdit',
        component: () => import('../views/learning/CourseEdit.vue'),
        meta: { title: '发布课程', activeMenu: '/learning/courses' },
        hidden: true
      },
      {
        path: '/learning/courses/records',
        name: 'CourseRecords',
        component: () => import('../views/learning/CourseRecords.vue'),
        meta: { title: '课程跟踪', activeMenu: '/learning/courses' },
        hidden: true
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: constantRoutes
})

export default router


